<template v-if="_inline">
	<div class="row" v-if="_row">
		<div class="form-group">
			<div :class="_css">
					<slot>
					</slot>
				</div>
			</div>
		</div>
	</div>
</template>

<template v-if="!_inline">
	<div class="row">
		<div class="form-group">
			<div :class="_css">
				<label class="col-sm-12 control-label">{{ _title }}</label>
				<div class="col-sm-12">
					<slot>
						<input class="form-control" required="required">
					</slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		inline: String,
		cols: {
			type: Number,
			default: 12
		},
		noRow: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		_title () {
			return typeof this.title === 'undefined' ? '' : this.title
		},

		_inline () {
			return !(typeof this.inline === 'undefined')
		},

		_css () {
			return 'col-lg-' + this.cols
		},

		row () {
			return !this.noRow
		}
	}
}
</script>



// WEBPACK FOOTER //
// custom-input.vue?333f43c8